//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetNoOrderShotSearch = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetNoOrderShotSearch,
        method: RequestType.POST,
        data,
    });

const NoOrderShotSearchQuery = {
    GetNoOrderShotSearch,
};

export default NoOrderShotSearchQuery;
